import useAppContext from "lib/hooks/use-app-context";
import Admin from "./admin";
import Public from "./public";

export default function Navbars() {
  const {user} = useAppContext();

  return (
    <>
      {user?.admin && <Admin />}
      <Public />
    </>
  );
}
